import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingPrice, TListBillingPricesParams } from './types';

export function useBillingPrices(params?: TListBillingPricesParams) {
  const query = new URLSearchParams();
  if (params?.suite) query.set('suite', params.suite);
  for (const status of params?.statuses ?? []) query.append('statuses', status);
  const suffix = query.size ? `?${query.toString()}` : '';

  const { data, error, isLoading, mutate } = useSWR<TBillingPrice[]>(
    `commenda-billing/catalog/prices${suffix}`,
    SWRFetcher({ method: 'GET' })
  );

  return { prices: data ?? [], error, isLoading, mutate };
}
